import { render, staticRenderFns } from "./ReferralPurchaseIndex.vue?vue&type=template&id=57e712cb&scoped=true"
import script from "./ReferralPurchaseIndex.vue?vue&type=script&lang=js"
export * from "./ReferralPurchaseIndex.vue?vue&type=script&lang=js"
import style0 from "./ReferralPurchaseIndex.vue?vue&type=style&index=0&id=57e712cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e712cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e712cb')) {
      api.createRecord('57e712cb', component.options)
    } else {
      api.reload('57e712cb', component.options)
    }
    module.hot.accept("./ReferralPurchaseIndex.vue?vue&type=template&id=57e712cb&scoped=true", function () {
      api.rerender('57e712cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/referral_purchase/ReferralPurchaseIndex.vue"
export default component.exports